module.exports = __webpack_public_path__ + "img/check-icon.a6072a4f.svg";